<template>
  <span class="value">
    <slot v-if="!value"></slot>
    <span v-else>{{ value }}</span>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
};
</script>
<style scoped lang="scss">
.value {
  flex: 1;
  color: $orderLineColor;
  font-size: $mediumTextSize;
}
</style>
